export enum EShortcutsDateContabil {
  ultimoAno,
  ultimosTresMeses,
  ultimoSemestre,
  ultimaAtualizacao
}
